<template>
    <div>
        <v-card v-if="itemTemplateData">
            <v-toolbar color="info" height="40" >
                <v-toolbar-title>
                    {{itemTemplateData.name}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="$emit('onCloseItemTemplate')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-data-table
                height="70vh"
                    :headers="headers"
                    :items="itemTemplateData.templateItems"
                    hide-actions
                    class="condensed-datatable"
                    >
                    <template slot="items" slot-scope="props">
                      <!-- <td class="py-1 px-1">
                          <v-img
                              :src="props.item.imgThumbnailUrl"
                              width="120"
                              aspect-ratio="1.5"
                              contain
                          >
                                <v-layout column fill-height class=" ">
                                    <v-spacer></v-spacer>
                                    <v-flex shrink pb-2>
                                        <div class="text-xs-center" v-if="!props.item.itemId">
                                            <v-btn small color="info" @click="$emit('onUploadItemImage', props.item)" >Upload Image</v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>
                          </v-img>
                      </td> -->

                      <td class="px-1 text-no-wrap">{{ props.item.itemCategory }}</td>
                      <td class="px-1">{{ props.item.itemDesc }}</td>
                      <td class="px-1">{{ props.item.itemNumber }}</td>
                      <td class="px-1 text-xs-center text-no-wrap">{{ props.item.itemUnit }}</td>
                      <td class="px-1 text-xs-center">
                        <v-text-field 
                            v-model="props.item.orderQty" 
                            type="number"
                            label=""
                            ></v-text-field>
                      </td>
                        <!-- <td>{{props.item.notes}}</td>
                        <td>
                            <v-btn small color="primary" 
                                v-show="canEditItem" @click.prevent="$emit('onEditItem', props.item)" >Edit</v-btn>
                            <v-btn small color="primary" @click.prevent="$emit('onDeleteItem', props.item)" >Delete</v-btn>
                        </td> -->
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-btn color="primary" @click.prevent="onSaveQuoteTemplate">Add Items to Quote</v-btn>
                    <v-btn color="warning" @click.prevent="$emit('onCloseItemTemplate')">Cancel</v-btn>
                </div>
            </v-card-text>
        </v-card>
<!-- {{ itemTemplateData }} -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    //the object of 
    props: ['qteTempSearchParas'],
    components: {
    },
    data() {
        return {
            itemTemplateData: null,
            headers: [
                { text: 'Product Category', sortable: false},
                { text: 'Item Description' , sortable: false},
                { text: 'Item Number', sortable: false},
                { text: 'UNIT' , sortable: false},
                { text: 'Order QTY.', sortable: false, class: ['px-1']},
            ],
        }
    },
    computed: {
    },
    watch: {

        'qteTempSearchParas': async function() {
            console.log('qteTempSearchParas has value changed')
            if(this.qteTempSearchParas) {
                this.itemTemplateData = await this.getQuoteTemplateForQuote(this.qteTempSearchParas)
            }
            // this.searchParas.priceTierId = this.priceTierId
            // if(this.searchParas.priceTierId) {
            //     this.onSearch(this.searchParas)
            // }
            // else{
            //     this.members = null
            //     this.pages = null
            // }
        },
    },
    methods: {
        ...mapActions('pubQuoteEdit', [
            'getQuoteTemplateForQuote',
            'saveQuoteTemplateForQuote',
        ]),
        async onSaveQuoteTemplate() {
            var result = await this.saveQuoteTemplateForQuote(this.itemTemplateData)
            console.log('result')
            console.log(result)
            this.$emit('onCloseItemTemplate')
            this.$emit('onTemplateItemSaved')
        }
    }
}
</script>
<style scoped>
/* Custom CSS */
.custom-condensed-table {
  /* Reduce padding */
  padding: 0;
}

.custom-condensed-table tbody tr td {
  /* Reduce cell padding */
  padding: 1px;
}

.custom-condensed-table thead th {
  /* Reduce header cell padding */
  padding: 8px;
}

.custom-condensed-table tbody tr td,
.custom-condensed-table thead th {
  /* Reduce font size */
  font-size: 12px;
}

.custom-condensed-table tbody tr {
  /* Reduce row height */
  height: 15px;
}

.custom-condensed-table thead th {
  /* Adjust header height */
  height: 30px;
}

.custom-condensed-table tbody tr {
  /* Make rows more compact */
  margin-bottom: 4px;
}

.custom-condensed-table tbody tr td,
.custom-condensed-table thead th {
  /* Reduce border thickness */
  border-width: 1px;
}
</style>